<template>
  <div class="boss-main-content-wrap">
    <setting-header
      v-if="isCompanyStaffAccess"
      :breadcrumbs="[{ name: '求人確認' }, isPrePublishedAccess ? { name: '掲載前の求人', pathName: 'jobPrePublished' } : { name: '掲載済みの求人・応募フォームタイプ設定', pathName: 'jobPublished' }]"
      :title="isPrePublishedAccess ? '掲載前のオプション情報プレビュー_フォトクリップ' : '掲載済みのオプション情報プレビュー_フォトクリップ' "
      class="hide-for-print"
    />
    <div class="pega-option-wrap">
      <div class="grid-x hide-for-print">
        <div class="cell auto">
          <sp-preview-button
            :id="id"
            :route-name="spRouteNameForPhotoClip"
          />
        </div>
        <print-button class="cell shrink" />
      </div>
      <div class="pega-text-small">
        ※「インタビュー」「フォトクリップ」は掲載時ご利用の場合のみ表示されます。
      </div>
      <photo-clip-preview-detail :photo-clip="photoClip" />
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import PhotoClipPreviewDetail from '@/components/organisms/PhotoClipPreviewDetail'
import SpPreviewButton from '@/components/atoms/SpPreviewButton'
import PrintButton from '@/components/atoms/PrintButton'
import photoClipPreviewCommon from '@/lib/photoClipPreviewCommon'

export default {
  components: {
    PrintButton,
    SpPreviewButton,
    SettingHeader,
    PhotoClipPreviewDetail
  },
  // PC・SP共通処理読み込み
  mixins: [photoClipPreviewCommon]
}
</script>
